import { render, staticRenderFns } from "./PToolbarAction.vue?vue&type=template&id=5ac34e9f"
import script from "./PToolbarAction.vue?vue&type=script&lang=js"
export * from "./PToolbarAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports